var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('qa-block',{attrs:{"datas":_vm.qanda_tutorial_datas,"title":_vm.question}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }